import { render, staticRenderFns } from "./stuDetail.vue?vue&type=template&id=08269024&scoped=true&"
import script from "./stuDetail.vue?vue&type=script&lang=js&"
export * from "./stuDetail.vue?vue&type=script&lang=js&"
import style0 from "./stuDetail.vue?vue&type=style&index=0&id=08269024&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08269024",
  null
  
)

export default component.exports